<template>
  <div>
    <gh-upload></gh-upload>
  </div>
</template>

<style scoped>

</style>

<script>
  import Index from "./index.ts";
  export default Index;
</script>